/* eslint-disable react/prop-types */
import {Leads} from './styles'

const LeadList = ({children}) => (
  <Leads>
    {children}
  </Leads>
)
export default LeadList
